export const DDC_ICON_PREFIX = 'ddc-icon-';

// WIAPI page modify locations
export const SERVICE_SCHEDULE_BUTTON = 'schedule-service';
